import HistoryIcon from '@mui/icons-material/History';
import { IconButton } from '@mui/material';
import type { InvoiceRow } from 'lib/api/business/types';
import React, { useCallback, useState } from 'react';

export const getCessionHistoryColumnConfig = (
  handleShowCessionHistory: (rowId: string) => void,
) => ({
  key: 'cessionaries',
  label: 'Cedida',
  type: 'cessionaries' as const,
  customComponent: (value: InvoiceRow['cessionaries'], row: InvoiceRow) => {
    const cessions = value ?? [];
    if (!Array.isArray(cessions) || cessions.length === 0) {
      return '--';
    }
    const displayText = cessions[0].cessionary ?? '--';
    return React.createElement(
      'div',
      { style: { display: 'flex', alignItems: 'center', gap: 4 } },
      React.createElement(
        IconButton,
        {
          size: 'small',
          onClick: (e: React.MouseEvent) => {
            e.stopPropagation();
            handleShowCessionHistory(row.id);
          },
        },
        React.createElement(HistoryIcon, { fontSize: 'small' }),
      ),
      displayText,
    );
  },
});

export type CessionHistoryItem = {
  giver: string;
  cessionary: string;
  cessionDate: string;
  cessionaryIdentifier: string;
  giverIdentifier: string;
};

const mapCessionariesToDialogFormat = (
  cessionaries: InvoiceRow['cessionaries'],
): CessionHistoryItem[] =>
  (cessionaries ?? []).map((c) => ({
    giver: c.giver,
    giverIdentifier: c.giverIdentifier,
    cessionary: c.cessionary,
    cessionaryIdentifier: c.cessionaryIdentifier,
    cessionDate: String(c.cessionDate),
  }));

export const useCessionHistoryDialog = (invoices: InvoiceRow[]) => {
  const [openCessionHistoryDialog, setOpenCessionHistoryDialog] =
    useState(false);
  const [selectedCessions, setSelectedCessions] = useState<
    CessionHistoryItem[]
  >([]);

  const handleShowCessionHistory = useCallback(
    (rowId: string) => {
      const row = invoices.find((x) => String(x.id) === String(rowId));
      if (!row) return;
      const cessions = mapCessionariesToDialogFormat(row.cessionaries);
      setSelectedCessions(cessions);
      setOpenCessionHistoryDialog(true);
    },
    [invoices],
  );

  return {
    openCessionHistoryDialog,
    setOpenCessionHistoryDialog,
    selectedCessions,
    handleShowCessionHistory,
  };
};
